import { useEffect } from "react";
import { storeApi } from "./storeApi";

/**
 * Fires a single page-view POST when the caller mounts. Uses window.location
 * so it works consistently across all storefront routes.
 */
export function usePageView(pathOverride) {
  useEffect(() => {
    const path = pathOverride || (typeof window !== "undefined" ? window.location.pathname : "/");
    const referrer = typeof document !== "undefined" ? document.referrer : "";
    storeApi.post("/store/track", { path, referrer }).catch(() => {
      /* swallow - analytics is best-effort, never break the storefront */
    });
  }, []);
}
